import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hotel-list-favorite-details" }
const _hoisted_2 = { class: "hotel-list-favorite-details__info-wrapper" }
const _hoisted_3 = { class: "hotel-list-favorite-details__info-content" }
const _hoisted_4 = { class: "hotel-list-favorite-details__link" }

import LinkButton from '@lmt-rpb/Atoms/LinkButton/LinkButton.vue';
import { useTranslations } from '@helper/composables/translations';


export default /*@__PURE__*/_defineComponent({
  __name: 'HotelListItemFavouriteDetails',
  props: {
    details: {}
  },
  setup(__props: any) {



const { translate } = useTranslations();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.details), 1 /* TEXT */)
    ]),
    _createElementVNode("span", _hoisted_4, [
      _createVNode(LinkButton, {
        as: "div",
        label: _unref(translate)('favouriteHotelList.favoriteDetailsLink')
      }, null, 8 /* PROPS */, ["label"])
    ])
  ]))
}
}

})